/**
 * Constantes de tipos de usuario.
 *
 * Estos valores deben coincidir con los definidos en el backend.
 */

export const USER_TYPES = {
  ADMIN: "ADMIN",
  VIGILANTE: "VIGILANTE",
  RESIDENTE: "RESIDENTE",
  CONSEJO: "CONSEJO",
  USUARIO: "USUARIO",
};

/**
 * Verifica si un tipo de usuario es válido.
 *
 * @param {string} tipo - Tipo de usuario a verificar
 * @returns {boolean}
 */
export const isValidUserType = (tipo) => {
  return Object.values(USER_TYPES).includes(tipo);
};

/**
 * Verifica si el usuario es residente.
 *
 * @param {string} tipo - Tipo de usuario
 * @returns {boolean}
 */
export const isResidente = (tipo) => tipo === USER_TYPES.RESIDENTE;

/**
 * Verifica si el usuario es admin.
 *
 * @param {string} tipo - Tipo de usuario
 * @returns {boolean}
 */
export const isAdmin = (tipo) => tipo === USER_TYPES.ADMIN;

/**
 * Verifica si el usuario es vigilante.
 *
 * @param {string} tipo - Tipo de usuario
 * @returns {boolean}
 */
export const isVigilante = (tipo) => tipo === USER_TYPES.VIGILANTE;
